import React from 'react';
import { List, ListItem, ListItemText, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import '../LoginSwitcher.scss';

const useStyles = makeStyles({
    list: {
        width: 239,
    },
    text: {
        color: '#013957',
        fontSize: 14,
    },
    listItem: {},
    listItem1: {
        margin: '16px 0 0 0',
        padding: '8px 16px 8px 45px'
    },
    listItem2: {
        padding: '8px 16px 8px 45px'
    },
    hr: {
        position: 'absolute',
        borderTop: '1px solid rgba(53, 185, 182, 0.3)',
        width: '106%',
    }
});

const SwitcherList = ({
    selectedIndex,
    handleListItemClick
}) => {

    const classes = useStyles()
    const isMobile = useMediaQuery('(max-width: 768.98px)')

    return (
        <List
            component="nav"
            classes={{ root: classes.list }}
        >
            {isMobile && <hr className={classes.hr} />}
            <ListItem
                button
                classes={{ root: isMobile ? classes.listItem1 : classes.listItem }}
                selected={isMobile ? false : selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
            >
                <ListItemText
                    primary="Perfil Abogado Premium"
                    classes={{ root: classes.text }}
                />
                {selectedIndex === 0 ?
                    <img
                        src='/img/switcher-login/mark.svg'
                        className='switcherList_mark'
                        alt='mark'
                    /> : null
                }
            </ListItem>
            <ListItem
                button
                classes={{ root: isMobile ? classes.listItem2 : classes.listItem }}
                selected={isMobile ? false : selectedIndex === 1}
                onClick={(event) => handleListItemClick(event, 1)}
            >
                <ListItemText
                    primary="Despacho Premium"
                    classes={{ root: classes.text }}
                />
                {selectedIndex === 1 ?
                    <img
                        src='/img/switcher-login/mark.svg'
                        className='switcherList_mark'
                        alt='mark'
                    /> : null
                }
            </ListItem>
        </List>
    )
}

export default SwitcherList;
